import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Form, Button } from 'semantic-ui-react';

const CreatedACLicensesList = ({
  codes,
  onReset
}) => {

  const [showCopied, setShowCopied] = useState(false);

  const onCopy = () => {
    navigator.clipboard.writeText(codes.join('\n'));
    setShowCopied(true);
  }

  useEffect(() => {
    const to = showCopied ? setTimeout(() => {
      setShowCopied(false);
    }, 3000) : null;
    return () => clearTimeout(to);
  }, [showCopied]);

  return (
    <Form size='tiny' onSubmit={ onCopy } >
      <Form.Field>
        <label>Success!</label>
        <textarea
          readOnly
          value={ codes.join('\n') }
        />
      </Form.Field>
      <Button.Group>
        <Button onClick={ onReset }>Return</Button>
        <Button positive type="submit" >{ showCopied ? 'Copied!' : 'Copy' }</Button>
      </Button.Group>
    </Form>
  );
};

CreatedACLicensesList.propTypes = {
  codes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onReset: PropTypes.func.isRequired
}

export default CreatedACLicensesList;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/createdACList.js